/* LUNA Holiday Shop behaviour. Small on purpose: the page should feel fast.
   1. In-page jumps ("Find their LUNAs" to the who-are-you-shopping-for cards) scroll smoothly.
   2. The phone-only sticky "Shop holiday gifts" bar appears once the hero has scrolled
      away and hides again at the closing section ([data-luna-hs-end]).
   3. One-tap "Add" on single-variant gift tiles, through the shared cart adapter
      (luna-cart.js), so the Rebuy drawer opens exactly as it does for Quick Add.
   4. The gift kit: "Shop the gift kit" opens the main sandal's own Quick Add so the
      shopper picks a size, and once that pair lands in the cart the kit's extras are
      added behind it. Nothing is added if they close the size sheet.
   5. Stamped review badges outside product cards (the Mono spotlight) get loaded.
   6. The free-gift discount code (Liv, 09-25, "route B"). The hero carries
      data-luna-hs-discount="CODE" plus the gift variant. Every outbound shop link on
      the page goes through /discount/CODE?redirect=... so the code follows the shopper
      to product and collection pages and applies itself at checkout; anything added
      on this page gets the code applied to the cart through the Ajax API; and after a
      sandal is added here the gift is added once, then removed again if the code did
      not make it free (code missing, expired, sandal not eligible). No code, no change.
   Motion (reveal on scroll, arrow drawing) is CSS driven off luna-motion.js's .is-in. */
(function(){
  if(window.__lunaHoliday) return; window.__lunaHoliday = true;

  /* 1. smooth jumps */
  document.addEventListener('click', function(e){
    var a = e.target.closest('a[href^="#"]');
    if(!a) return;
    var id = a.getAttribute('href').slice(1);
    if(!id) return;
    var t = document.getElementById(id);
    if(!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior:'smooth', block:'start' });
    try{ history.replaceState(null, '', '#' + id); }catch(err){}
  });

  /* 2. sticky bar */
  function sticky(){
    var bar = document.querySelector('.luna-hs-sticky');
    if(!bar || bar.__on) return;
    bar.__on = true;
    var hero = document.querySelector('.luna-hs-hero');
    var end = document.querySelector('[data-luna-hs-end]');
    /* Checked on scroll with a 16ms throttle, not an IntersectionObserver: an observer only
       reports CHANGES in intersection, so an instant jump (anchor link, restored scroll
       position, a fast flick on a slow frame) that carries the hero straight out of view
       never fired it and the bar stayed hidden. One getBoundingClientRect per frame is nothing. */
    var ticking = false;
    function sync(){
      ticking = false;
      var heroOut = !hero || hero.getBoundingClientRect().bottom <= 0;
      var endIn = !!end && end.getBoundingClientRect().top < window.innerHeight;
      /* desktop may show the bar from the first view (hero setting); phones wait for the hero */
      var now = window.innerWidth >= 750 && bar.getAttribute('data-desktop-now') === 'true';
      var on = (heroOut || now) && !endIn;
      bar.classList.toggle('is-on', on);
      document.documentElement.classList.toggle('luna-hs-bar-over-hero', on && !heroOut);
      /* phones: the chat launcher hops above the bar (CSS reads the class + height) */
      if(on) document.documentElement.style.setProperty('--hs-bar-h', (bar.offsetHeight || 74) + 'px');
      document.documentElement.classList.toggle('luna-hs-bar-on', on);
    }
    /* a short timeout, not requestAnimationFrame: rAF never runs while the tab is hidden, so a
       scroll that lands while the page is in the background left the throttle stuck shut */
    function onScroll(){ if(!ticking){ ticking = true; setTimeout(sync, 16); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    /* safety net: scroll events only arrive while the page is rendering, so a scroll position
       restored in a background tab, or a jump made before paint, can land without one. One
       cheap check a second keeps the bar honest either way. */
    setInterval(sync, 1000);
    sync();
  }
  function addItems(items){
    if(window.lunaCart && window.lunaCart.add) return window.lunaCart.add(items);
    return fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function(r){ return r.json(); });
  }
  function track(name, detail){
    try{
      if(window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, detail || {}));
      if(window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, detail || {});
    }catch(e){}
  }

  /* 3. one-tap gift add */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-luna-hs-add]');
    if(!b || b.disabled) return;
    e.preventDefault();
    var id = parseInt(b.getAttribute('data-luna-hs-add'), 10);
    if(!id) return;
    var label = b.querySelector('span');
    var was = label ? label.textContent : '';
    b.disabled = true; if(label) label.textContent = 'Adding';
    addItems([{ id:id, quantity:1 }]).then(function(){
      b.classList.add('is-done'); if(label) label.textContent = 'Added';
      track('luna_holiday_gift_add', { variant_id:id });
      setTimeout(function(){ b.classList.remove('is-done'); b.disabled = false; if(label) label.textContent = was; }, 2400);
    }).catch(function(){
      b.disabled = false; if(label) label.textContent = was;
      var url = b.getAttribute('data-luna-hs-url'); if(url) window.location.href = url;
    });
  });

  /* 3b. one-variant products: the standard Quick Add pill adds straight to the cart instead of
     opening a sheet with nothing to choose. Capture phase, so luna-card.js never sees the click. */
  document.addEventListener('click', function(e){
    var qa = e.target.closest('.luna-hs button.luna-card__qa');
    if(!qa) return;
    var card = qa.closest('.luna-card');
    var dataEl = card && card.querySelector('[data-luna-data]');
    if(!dataEl) return;
    var data; try{ data = JSON.parse(dataEl.textContent); }catch(err){ return; }
    if(!data || !data.variants || data.variants.length !== 1) return;
    var v = data.variants[0];
    if(!v.a) return;
    e.preventDefault(); e.stopPropagation();
    var label = qa.querySelector('span'); var was = label ? label.textContent : '';
    qa.disabled = true; if(label) label.textContent = 'Adding';
    addItems([{ id: v.id, quantity: 1 }]).then(function(){
      if(label) label.textContent = 'Added';
      track('luna_holiday_gift_add', { variant_id: v.id });
      setTimeout(function(){ qa.disabled = false; if(label) label.textContent = was; }, 2400);
    }).catch(function(){ qa.disabled = false; if(label) label.textContent = was; });
  }, true);

  /* 3c. Quick Add beside the price (Liv, 09-28): move each card's pill from the photo bar
     into the body; luna-card.js's click handler travels with the element. Cards that arrive
     later (tab panels cloned on first select) are caught by the observer. */
  function placeQa(card){
    if(!card.closest('.luna-hs')) return;
    var qa = card.querySelector('.luna-card__qa'), body = card.querySelector('.luna-card__body');
    if(!qa || !body || qa.parentNode === body) return;
    body.appendChild(qa); card.classList.add('luna-hs-qa');
  }
  function placeAll(root){ (root || document).querySelectorAll('.luna-hs .luna-card').forEach(placeQa); }
  if('MutationObserver' in window){
    new MutationObserver(function(muts){
      muts.forEach(function(m){
        Array.prototype.forEach.call(m.addedNodes, function(n){
          if(n.nodeType !== 1) return;
          if(n.matches && n.matches('.luna-card')) placeQa(n);
          else if(n.querySelectorAll) n.querySelectorAll('.luna-card').forEach(placeQa);
        });
      });
    }).observe(document.documentElement, { childList:true, subtree:true });
  }

  /* 4. gift kit */
  document.addEventListener('click', function(e){
    var b = e.target.closest('[data-luna-hs-kit]');
    if(!b) return;
    var kit = b.closest('.luna-hs-kit');
    var qa = kit && kit.querySelector('button.luna-card__qa');
    if(!qa) return; /* no quick add on the page: the button is a plain link to the sandal */
    e.preventDefault();
    var extras = [];
    try{ extras = JSON.parse(kit.getAttribute('data-luna-hs-extras') || '[]'); }catch(err){}
    window.__lunaHsKit = { extras: extras, main: parseInt(kit.getAttribute('data-luna-hs-main'), 10), at: Date.now() };
    track('luna_holiday_kit_start', {});
    var card = qa.closest('.luna-card');
    if(card && card.scrollIntoView && window.matchMedia('(min-width:750px)').matches){
      card.scrollIntoView({ behavior:'smooth', block:'center' });
    }
    setTimeout(function(){ qa.click(); }, 120);
  });
  document.addEventListener('luna:added', function(e){
    var k = window.__lunaHsKit;
    if(!k || !k.extras.length) return;
    var cart = e.detail && e.detail.cart;
    var hasMain = !k.main || !cart || (cart.items || []).some(function(i){ return i.product_id === k.main; });
    if(!hasMain) return;               /* they added something else; leave the kit armed */
    window.__lunaHsKit = null;
    if(Date.now() - k.at > 10 * 60 * 1000) return;
    var items = k.extras.map(function(id){ return { id:id, quantity:1 }; });
    fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function(r){ return r.json(); })
      .then(function(){
        track('luna_holiday_kit_complete', { extras: k.extras });
        return fetch('/cart.js', { headers:{ 'Accept':'application/json' } }).then(function(r){ return r.json(); })
          .then(function(c){ if(window.lunaCart) window.lunaCart.refreshCounts(c); document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true })); });
      }).catch(function(){});
  });

  /* 5. review badges outside cards */
  function badges(){
    try{
      if(!window.StampedFn) return false;
      if(typeof StampedFn.loadBadges === 'function') StampedFn.loadBadges();
      else if(typeof StampedFn.reloadUUID === 'function') StampedFn.reloadUUID();
      return true;
    }catch(e){ return false; }
  }
  function badgesSoon(){
    var tries = 0;
    (function tick(){ if(badges() || ++tries > 20) return; setTimeout(tick, 600); })();
  }

  /* 6. free-gift discount code */
  function cfg(){
    var el = document.querySelector('[data-luna-hs-discount]');
    if(!el) return null;
    var code = (el.getAttribute('data-luna-hs-discount') || '').trim();
    if(!code) return null;
    return { code: code, gift: parseInt(el.getAttribute('data-luna-hs-gift-variant'), 10) || 0,
             auto: el.getAttribute('data-luna-hs-gift-auto') === 'true' };
  }
  function routeLinks(root){
    var c = cfg(); if(!c) return;
    var rx = /^\/(products|collections)\//;
    function fix(a){
      var href = a.getAttribute('href') || '';
      if(href.indexOf('/discount/') === 0) return;
      if(!(rx.test(href) || href.indexOf('/pages/sandal-picker') === 0)) return;
      a.setAttribute('href', '/discount/' + encodeURIComponent(c.code) + '?redirect=' + encodeURIComponent(href));
    }
    var scope = root || document;
    scope.querySelectorAll('.luna-hs [role="tab"][data-url]').forEach(function(t){
      var u = t.getAttribute('data-url') || '';
      if(u.indexOf('/discount/') === 0 || !(rx.test(u) || u.indexOf('/pages/sandal-picker') === 0)) return;
      t.setAttribute('data-url', '/discount/' + encodeURIComponent(c.code) + '?redirect=' + encodeURIComponent(u));
      var all = t.closest('[data-luna-tabs]') && t.closest('[data-luna-tabs]').querySelector('[data-luna-viewall]');
      if(all && t.getAttribute('aria-selected') === 'true') all.setAttribute('href', t.getAttribute('data-url'));
    });
    scope.querySelectorAll('.luna-hs a[href^="/"]').forEach(fix);
    scope.querySelectorAll('.luna-hs template').forEach(function(t){ t.content.querySelectorAll('a[href^="/"]').forEach(fix); });
  }
  function cartJson(){ return fetch('/cart.js', { headers:{ 'Accept':'application/json' } }).then(function(r){ return r.json(); }); }
  function post(url, body){
    return fetch(url, { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json(); });
  }
  function applyCode(code){ return post('/cart/update.js', { discount: code }).catch(function(){ return null; }); }
  /* What counts as "a sandal" for the free gift, page-side. The discount itself decides for
     real (its Buy X collection); this only drives the auto-add and the bar's wording. */
  function isSandal(i){ return /sandal/i.test(i.product_type || ''); }
  function giftAfter(cart){
    var c = cfg(); if(!c || !c.auto || !c.gift || !cart || !cart.items) return;
    var key = 'luna.hs.gift';
    try{ if(sessionStorage.getItem(key)) return; }catch(e){}
    if(cart.items.some(function(i){ return i.variant_id === c.gift; })) return;
    if(!cart.items.some(isSandal)) return;
    /* "free" is judged two ways, because Shopify reports a Buy X get Y on the line but
       reports some discounts only in the cart total: the gift line comes back at $0, or
       the cart's total discount grew by at least the gift's price when it was added. */
    var before = 0;
    cartJson()
      .then(function(c1){ before = c1.total_discount || 0;
        return post('/cart/add.js', { items:[{ id:c.gift, quantity:1, properties:{ _holiday_gift:'Holiday Shop' } }] }); })
      .then(cartJson)
      .then(function(c2){
        var line = null;
        c2.items.forEach(function(i){ if(i.variant_id === c.gift) line = i; });
        if(!line) return c2;
        var grew = (c2.total_discount || 0) - before;
        var free = line.final_line_price === 0 || grew >= line.price;
        if(!free){ return post('/cart/change.js', { id: line.key, quantity: 0 }); }
        try{ sessionStorage.setItem(key, '1'); }catch(e){}
        track('luna_holiday_gift_auto', { variant_id: c.gift });
        return c2;
      })
      .then(function(c3){
        if(window.lunaCart && c3 && c3.items) window.lunaCart.refreshCounts(c3);
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles:true }));
      })
      .catch(function(){});
  }
  document.addEventListener('luna:added', function(e){
    var c = cfg(); if(!c) return;
    applyCode(c.code).then(function(){ giftAfter(e.detail && e.detail.cart); });
  });
  function codeOnLoad(){
    var c = cfg(); if(!c) return;
    cartJson().then(function(cart){ if(cart && cart.item_count > 0) applyCode(c.code); }).catch(function(){});
  }

  /* ---------- sticky gift bar (Liv, 09-28: "make it a habit on the page") ----------
     The bar reads the cart and shows one of three states:
       shop  no sandal in the cart yet: the button adds the bag at its normal price and the
             small line says it is free with any sandal (Shopify re-prices the line to $0 the
             moment an eligible sandal joins it, because a Buy X get Y applies to the Y already
             in the cart).
       free  a sandal is in the cart: "Add free bag". The code is applied first, then the bag.
       in    the bag is already in the cart: the button opens the cart drawer instead.
     The price line is judged from the REAL cart line, so before the code exists in Shopify
     the bar honestly shows the bag's price rather than "Free". */
  function bar(){
    var el = document.querySelector('[data-luna-hs-bar]');
    /* own flag: sticky() already stamps __on on this same element (it carries both classes) */
    if(!el || el.__hsBar) return;
    el.__hsBar = true;
    var c = cfg();
    var gift = (c && c.gift) || parseInt(el.getAttribute('data-gift-variant'), 10) || 0;
    var btn = el.querySelector('[data-luna-hs-bar-add]'), price = el.querySelector('[data-luna-hs-bar-price]');
    if(!gift || !btn || !price) return;
    var L = { add: el.getAttribute('data-l-add') || 'Add to cart', free: el.getAttribute('data-l-free') || 'Add free bag',
              incart: el.getAttribute('data-l-in') || 'In your cart', word: el.getAttribute('data-l-free-word') || 'Free',
              label: el.getAttribute('data-price-label') || '' };
    var state = 'shop';
    function setPrice(free){
      price.textContent = '';
      if(free){
        var s = document.createElement('s'); s.textContent = L.label;
        var b = document.createElement('b'); b.textContent = L.word;
        price.appendChild(s); price.appendChild(b);
      }else{ price.textContent = L.label; }
    }
    function render(cart){
      if(!cart || !cart.items) return;
      var line = null; cart.items.forEach(function(i){ if(i.variant_id === gift) line = i; });
      var eligible = cart.items.some(isSandal);
      state = line ? 'in' : (eligible ? 'free' : 'shop');
      el.setAttribute('data-state', state);
      setPrice(line ? line.final_line_price === 0 : eligible);
      btn.disabled = false;
      btn.textContent = state === 'in' ? L.incart : (state === 'free' ? L.free : L.add);
    }
    var t = null;
    function refresh(){ clearTimeout(t); t = setTimeout(function(){ cartJson().then(render).catch(function(){}); }, 300); }
    btn.addEventListener('click', function(){
      if(state === 'in'){ if(window.lunaCart && window.lunaCart.reveal) window.lunaCart.reveal(); return; }
      btn.disabled = true; btn.textContent = 'Adding';
      (c && c.code ? applyCode(c.code) : Promise.resolve())
        .then(function(){ return addItems([{ id: gift, quantity: 1, properties: { _holiday_gift: 'Holiday Shop' } }]); })
        .then(function(cart){
          try{ sessionStorage.setItem('luna.hs.gift', '1'); }catch(e){}
          track('luna_holiday_bar_add', { variant_id: gift, state: state });
          if(cart && cart.items) render(cart); else refresh();
        })
        .catch(function(){ btn.disabled = false; btn.textContent = state === 'free' ? L.free : L.add; });
    });
    document.addEventListener('luna:added', function(e){ if(e.detail && e.detail.cart) render(e.detail.cart); else refresh(); });
    ['rebuy:cart.change','rebuy:cart.add','rebuy:cart.remove','rebuy:smartcart.change','cart:refresh']
      .forEach(function(ev){ document.addEventListener(ev, refresh); });
    refresh();
  }
  function headerOffset(){
    var hero = document.querySelector('.luna-hs-hero');
    if(!hero) return;
    var top = Math.round(hero.getBoundingClientRect().top + window.scrollY);
    if(top > 0 && top < 400) document.documentElement.style.setProperty('--hs-header-offset', top + 'px');
  }
  function init(){ sticky(); bar(); routeLinks(document); headerOffset(); placeAll(document); if(document.querySelector('.luna-hs .stamped-product-reviews-badge')) badgesSoon(); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(); codeOnLoad(); }); else { init(); codeOnLoad(); }
  document.addEventListener('shopify:section:load', function(e){ init(); routeLinks(e.target); });
})();
